import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { MuiThemeProvider } from '@material-ui/core/styles';
import Calendar from 'material-ui-pickers/DatePicker/Calendar';
import withUtils from 'material-ui-pickers/_shared/WithUtils';
import DomainPropTypes from 'material-ui-pickers/constants/prop-types';
import startOfWeek from 'date-fns/startOfWeek';
import eachDayOfInterval from 'date-fns/eachDayOfInterval';
import endOfWeek from 'date-fns/endOfWeek';
import format from 'date-fns/format';

const updatedTheme = theme => ({
  ...theme,
  overrides: {
    ...theme.overrides,
    MuiTypography: {
      body1: {
        color: '#75787B'
      }
    }
  }
})

class DatePicker extends PureComponent {

  constructor(props){
    super()
    const { utils } = props;
    utils.getWeekdays = function() {
      const now = new Date();
      return eachDayOfInterval(
        {
          start: startOfWeek(now, { locale: this.locale }),
          end: endOfWeek(now, { locale: this.locale }),
        },
        { locale: this.locale },
      ).map(day => format(day, 'dd', { locale: this.locale })[0]);
    }
  }
  static propTypes = {
    /** Datepicker value */
    value: DomainPropTypes.date,
    /** Min selectable date */
    minDate: DomainPropTypes.date,
    /** Max selectable date */
    maxDate: DomainPropTypes.date,
    /** Callback firing when date accepted */
    onChange: PropTypes.func.isRequired,
    /** Disable past dates */
    disablePast: PropTypes.bool,
    /** Disable future dates */
    disableFuture: PropTypes.bool,
    /** To animate scrolling to current year (with scrollIntoView) */
    animateYearScrolling: PropTypes.bool,
    /** Open datepicker from year selection */
    openToYearSelection: PropTypes.bool,
    /** Left arrow icon */
    leftArrowIcon: PropTypes.node,
    /** Right arrow icon */
    rightArrowIcon: PropTypes.node,
    /** Custom renderer for day renderDay(date, selectedDate, dayInCurrentMonth) */
    renderDay: PropTypes.func,
    /** Disable specific date */
    shouldDisableDate: PropTypes.func,
    /** Enables keyboard listener for moving between days in calendar */
    allowKeyboardControl: PropTypes.bool
  };
  static defaultProps = {
    date: new Date(),
    format: 'MMMM Do',
    autoOk: false,
    minDate: '1900-01-01',
    maxDate: '2100-01-01',
    disableFuture: false,
    disablePast: false,
    animateYearScrolling: false,
    openToYearSelection: false,
    allowKeyboardControl: true,
    leftArrowIcon: 'keyboard_arrow_left',
    rightArrowIcon: 'keyboard_arrow_right',
    renderDay: undefined,
    shouldDisableDate: undefined
  };

  get date() {
    return this.props.utils.startOfDay(this.props.date);
  }

  get minDate() {
    return this.props.utils.date(this.props.minDate);
  }

  get maxDate() {
    return this.props.utils.date(this.props.maxDate);
  }

  render(){
    const {
      allowKeyboardControl,
      disableFuture,
      disablePast,
      leftArrowIcon,
      onChange,
      renderDay,
      rightArrowIcon,
      shouldDisableDate,
      utils
    } = this.props;

    return (
      <MuiThemeProvider theme={updatedTheme}>
         <Calendar
            date={this.date}
            onChange={onChange}
            disablePast={disablePast}
            disableFuture={disableFuture}
            minDate={this.minDate}
            maxDate={this.maxDate}
            leftArrowIcon={leftArrowIcon}
            rightArrowIcon={rightArrowIcon}
            renderDay={renderDay}
            utils={utils}
            shouldDisableDate={shouldDisableDate}
            allowKeyboardControl={allowKeyboardControl}
          />
      </MuiThemeProvider>
    );
  }
}

export default withUtils()(DatePicker)


// WEBPACK FOOTER //
// ./src/components/DatePicker/index.js